import React from 'react';
import * as Constants from "../../Common/constants";
import styled from 'styled-components';

const Span = styled.span`
  font-size: 15px;
  padding:10px;
`;


export default class ReportItem extends React.Component {
    
    

    componentWillMount() {

    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {

    }

    shouldComponentUpdate() {
        return true;
    }

    componentWillUpdate() {
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
    }


    onChange(e) {

    }


    render() {
        console.info('ReportItem - render called.', this.props);

        var date = new Date(this.props.data.timeinms);
        let timestr = date.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, "$1");
        let playerid = this.props.data.playerid;
        let strokeindex = this.props.data.strokeindex;
        let holeindex = this.props.data.holeindex;
        var title = this.getTitle(this.props.data);
        let scout = this.props.data.scout;

        let { fontcolor, backgroundcolor } = getColors(this.props.data);


        return (
            <div style={{ border: '2px solid green', padding: 5, margin: 5, backgroundColor: backgroundcolor, color: fontcolor }}>
                <div style={{ flex: 1 }}>
                    <span style={{ paddingLeft: 0, flex: 0.5 }}>{title}</span>
                    <span style={{ flex: 0.5, float: 'right', paddingRight: 10 }}>{timestr}</span>

                </div>
                <br />
                <Span>Player {playerid}</Span>
                <Span>Hole {holeindex}</Span>
                <Span>Shot {strokeindex}</Span>
                <Span> - {scout}</Span>
            </div>
        );
    }

    getTitle(item) {
        var title = null;
        switch (item.type) {
            case Constants.EVENT_TYPE_PREPARE_HIT:
                title = "Preparing to hit";
                break;
            case Constants.EVENT_TYPE_HIT:
                return "Hit - Ball in the air";
                break;
            case Constants.EVENT_TYPE_STROKE:
                var value = item.stroke ? item.stroke : JSON.parse(item.value);
                let lie = value.lie;

                title = " Shot end" + (lie ? " - " + lie : "") + " ";
                break;
            case Constants.EVENT_TYPE_RESULT:
                var value = item.value ? JSON.parse(item.value):{
                result: item.result};
                title = "Hole result: " + getResultString(value.result);
                break;
            default:
                break;
        }
        return title;

    }
}

function getResultString(result) {
    var string = "";
    switch (result) {
        case 0:
        string = "PAR";
            break;
        case 1:
        string = "BOGEY";
            break;
        case 2:
        string = "D.BOGEY";
            break;
        case -1:
        string = "BIRDIE";
            break;
        case -2:
        string ="EAGLE";
            break;
        default:
        string ="OTHER";
            break;
    }

    return string;
}

function getColors(item) {
    if (item.type === Constants.EVENT_TYPE_RESULT) {

        var value = item.value ? JSON.parse(item.value):{
            result: item.result};
        if (value.result === -2) {
            return {
                fontcolor: 'white',
                backgroundcolor: 'blue'
            };
        } else
            if (value.result === -1) {
                return {
                    fontcolor: 'white',
                    backgroundcolor: 'red'
                };
            }
        if (value.result === 0) {
            return {
                fontcolor: 'white',
                backgroundcolor: 'green'
            };
        } else if (value.result=== 1) {
            return {
                fontcolor: 'black',
                backgroundcolor: 'lightgrey'
            };
        } else if (value.result=== 2) {
            return {
                fontcolor: 'white',
                backgroundcolor: 'grey'
            };
        }else  {
            return {
                fontcolor: 'white',
                backgroundcolor: 'black'
            };
        }

    }
    return {
        fontcolor: 'black',
        backgroundcolor: 'white'
    };


}


// WEBPACK FOOTER //
// ./src/Components/ReportItem/ReportItem.js